import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=49169bc4&scoped=true"
import script from "./CustomReports.vue?vue&type=script&lang=ts"
export * from "./CustomReports.vue?vue&type=script&lang=ts"
import style0 from "./CustomReports.vue?vue&type=style&index=0&id=49169bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49169bc4",
  null
  
)

export default component.exports